export default function IsIos($DOM, classes) {
	const iDevices = [
		'iPad Simulator',
		'iPhone Simulator',
		'iPod Simulator',
		'iPad',
		'iPhone',
		'iPod',
		'MacIntel'
	];

	if (!!navigator.platform) {
		while (iDevices.length) {
			if (navigator.platform === iDevices.pop()){
				$DOM.bodyTag.addClass(classes.IsIos);
			}
		}
	}

	return false;
}